// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page_wrapper__2FpUM","desktop":"Page_desktop__21nvB"};